import {
  ColumnWidthClassNames,
  ColumnWidthStrings,
  ItemColumnSegmentWidths,
} from 'flux/stores/cuesheet/CuesheetConstants';

export const getDataCellWidthName = (column) => {
  return column.get('width') || ColumnWidthClassNames.Narrow;
};

export const getNoteCellWidthName = (userSettings) => {
  return (
    userSettings.getIn(['noteColumn', 'width']) || ColumnWidthClassNames.Narrow
  );
};

export const getItemCellWidthName = (settings) => {
  return (
    settings.getIn(['itemColumn', 'width']) || ColumnWidthClassNames.Narrow
  );
};

// User for compact view
export const getCompactItemCellWidthName = (settings) => {
  return (
    settings.getIn(['itemColumn', 'width']) || ColumnWidthClassNames.Narrow
  );
};

export const getGlobalItemCellWidthName = () => {
  return ColumnWidthClassNames.UltraNarrow;
};

export const getCompactItemCellWidthValue = (settings) => {
  let activeClassName = settings
    ? settings.getIn(['itemColumn', 'width'])
    : ColumnWidthStrings.Narrow;

  let classNameLookup = {};

  Object.keys(ColumnWidthStrings).forEach((width) => {
    classNameLookup[ColumnWidthStrings[width]] = ItemColumnSegmentWidths[width];
  });

  return classNameLookup[activeClassName] || ItemColumnSegmentWidths.Normal;
};

//Use for grid title column
export const getItemTitleCellWidthName = (settings) => {
  return (
    settings.getIn(['itemTitleColumn', 'width']) || ColumnWidthClassNames.Narrow
  );
};

//Use for grid description column
export const getItemDescriptionCellWidthName = (settings) => {
  return (
    settings.getIn(['itemDescriptionColumn', 'width']) ||
    ColumnWidthClassNames.Narrow
  );
};
